import Vue from "vue"
export default function directive(){
  return Vue.directive ("loadmore", {
    bind (el, binding) {
      //Get the scroll box defined by element-ui
      const selectwrap_dom = el.querySelector(".el-select-dropdown .el-select-dropdown__wrap")
      selectwrap_dom.addEventListener("scroll", function () {
        const condition = (this.scrollHeight - (Math.trunc(this.scrollTop)+1)) <= this.clientHeight
        if (condition){
          binding.value()
        }
      })
    }
  })
}
